import { useState, useEffect, useRef } from 'react';
import {
  Calculator, Warehouse, CheckCircle2, Menu, X, ShieldCheck, Truck, Box, XOctagon,
  Printer, History, Users, MonitorSmartphone, ArrowUpRight, Phone, Send, ClipboardList,
  Scale, FileCheck2, ChevronDown, Wifi, BatteryFull, ArrowLeftRight, Loader2
} from 'lucide-react';

// ⚙️ SOZLAMALAR - joylashdan oldin tekshiring
const DASHBOARD_URL = 'https://my.hosilim.uz/dashboard';
const PHONE_DISPLAY = '+998 91 777 01 37';
const PHONE_LINK = 'tel:+998917770137';
const TELEGRAM_URL = 'https://t.me/bilol_11111111'; // o'zingiznikini qo'ying
const HERO_BG = '/assets/hero.jpg'; // bo'lmasa '/assets/peach.jpg'
// Arizalar qabul qilinadigan manzil (backend yoki Telegram bot). Bo'sh bo'lsa forma ko'rinmaydi.
const LEAD_ENDPOINT = '';

const HAS_TELEGRAM = !TELEGRAM_URL.includes('[');

// ---------- MA'LUMOTLAR ----------
const navItems = [
  { id: 'compare', label: 'Daftar va Hosilim' },
  { id: 'demo', label: "Sinab ko'rish" },
  { id: 'features', label: 'Imkoniyatlar' },
  { id: 'pricing', label: 'Tariflar' },
  { id: 'faq', label: 'Savollar' },
  { id: 'contact', label: "Bog'lanish" }
];

const feedData = [
  { name: 'Akmal aka', kg: 420, price: 9000, crates: 30 },
  { name: 'Dilshod aka', kg: 780, price: 8500, crates: 52 },
  { name: 'Rustam aka', kg: 315, price: 9200, crates: 21 },
  { name: 'Sherzod aka', kg: 1040, price: 8800, crates: 70 },
  { name: 'Bahodir aka', kg: 560, price: 9000, crates: 38 },
  { name: 'Jasur aka', kg: 690, price: 8700, crates: 46 }
];

const stepsData = [
  { time: 'Ertalab', title: 'Karzinka tarqatish', desc: "Qaysi bog'bonga nechta karzinka berilgani planshetga yoziladi.", icon: <ClipboardList size={28} /> },
  { time: 'Kechqurun', title: 'Mahsulot qabuli', desc: "Og'irlik, narx va qaytgan karzinkalar kiritiladi. Summa o'zi hisoblanadi.", icon: <Scale size={28} /> },
  { time: 'Hisob-kitob', title: 'Tayyor natija', desc: "Kimga qancha to'lash kerakligi tayyor. Hisobotni bir tugma bilan chop etasiz.", icon: <FileCheck2 size={28} /> }
];

const featuresData = [
  { title: 'Karzinka hisobi', desc: "Berilgan va qaytgan karzinkalar yoziladi. Har bir bog'bonning qoldig'i doim ko'rinib turadi.", icon: <Box size={26} /> },
  { title: 'Tezkor qabul', desc: "Og'irlik, narx va karzinkalar bir marta kiritiladi, yakuniy summa avtomatik chiqadi.", icon: <Scale size={26} /> },
  { title: "Bog'bonlar bilan hisob-kitob", desc: "Kim qancha topshirgani, qancha to'langani va qarzdorlik bir joyda.", icon: <Calculator size={26} /> },
  { title: 'Sovuq ombor (xolodilnik)', desc: 'Har bir partiya qachon kirgani, saqlanish muddati va harorati qayd etiladi.', icon: <Warehouse size={26} /> },
  { title: 'Eksport logistikasi', desc: 'Mashinaga ortilgan yuk kuzatiladi, nakladnoy va yuk hujjatlari avtomatik tayyorlanadi.', icon: <Truck size={26} /> },
  { title: 'Shaffof tarix', desc: 'Kim, qachon, qancha topshirgani yagona bazada. Bahsli holatda hammasi yozilgan.', icon: <ShieldCheck size={26} /> }
];

const benefitsData = [
  { title: 'Buxgalteriya bilimi shart emas', desc: "Ma'lumotni har qanday xodim kirita oladi. Ish bitta odamga bog'lanib qolmaydi.", icon: <Users size={30} />, bgImage: '/assets/buxgalter.jpg' },
  { title: 'Hisobot bir zumda', desc: "Qabul tugashi bilan jami tonna va summani ko'rasiz, bir tugma bilan chop etasiz.", icon: <Printer size={30} />, bgImage: '/assets/hisob.jpg' },
  { title: 'Bitta planshet yetarli', desc: "Bir nechta daftar o'rniga bitta planshet yoki noutbuk. Qo'lda hisoblash xatolari keskin kamayadi.", icon: <MonitorSmartphone size={30} />, bgImage: '/assets/planshet.webp' },
  { title: "Ma'lumotlar yo'qolmaydi", desc: "Hammasi bulutli serverda. Planshet sinsa ham, tarif tugasa ham ma'lumotlar joyida.", icon: <History size={30} />, bgImage: '/assets/data.jpg' }
];

const pricingData = [
  {
    title: 'Go', desc: 'Kichik qabul punktlari uchun', price: '689 $', theme: 'light',
    features: [['Karzinka hisobi', true], ['Avtomatik hisob-kitob', true], ['Arxiv (cheklangan muddat)', true], ['Sovuq ombor nazorati', false], ['Hosilim ilovasi (bonus)', false]]
  },
  {
    title: 'Pro', desc: "O'rta va yirik qabul punktlari, dallollar uchun", price: '899 $', theme: 'primary', badge: 'Tavsiya etiladi',
    features: [['Karzinka hisobi', true], ['Avtomatik hisob-kitob', true], ['Arxiv (cheklangan muddat)', true], ['Sovuq ombor nazorati', true], ['Hosilim ilovasi (bonus)', false]]
  },
  {
    title: 'Ultra', desc: 'Katta hajm va logistika bilan ishlaydigan kompaniyalar uchun', price: '1399 $', theme: 'dark',
    features: [['Karzinka hisobi', true], ['Avtomatik hisob-kitob', true], ['Cheklanmagan arxiv', true], ['Sovuq ombor nazorati', true], ['Hosilim ilovasi (bonus)', true]]
  }
];

const faqData = [
  { q: 'Buxgalter kerakmi?', a: "Yo'q. Tonna, narx va qarzdorlik tizimda avtomatik hisoblanadi, ma'lumotni har qanday xodim kirita oladi." },
  { q: 'Qaysi qurilmada ishlaydi?', a: "Planshet yoki noutbukda. Bir nechta daftar o'rniga bitta qurilma yetarli." },
  { q: "Planshet sinsa yoki yo'qolsa, ma'lumotlar nima bo'ladi?", a: "Ma'lumotlar bulutli serverda saqlanadi. Yangi qurilmada kirib, ishni davom ettirasiz." },
  { q: "Tarif tugasa, ma'lumotlarim o'chib ketadimi?", a: "Yo'q, ma'lumotlar saqlanib qoladi. Qaysi bog'bon qancha yuk topshirganini keyin ham ko'rasiz." },
  { q: "Qanday boshlasam bo'ladi?", a: "Ariza qoldiring, qo'ng'iroq qiling yoki Telegram'da yozing. Tizimni ko'rsatib, mos tarifni tanlashga yordam beramiz." }
];

const planOptions = ['Hali bilmayman', 'Go', 'Pro', 'Ultra'];

// ---------- YORDAMCHILAR ----------
const fmt = (n) => String(Math.round(n)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

const formatPhone = (v) => {
  let d = v.replace(/\D/g, '');
  if (d.length < 3 || !d.startsWith('998')) d = '998' + d.replace(/^9?9?8?/, '');
  d = d.slice(0, 12);
  const parts = [d.slice(0, 3), d.slice(3, 5), d.slice(5, 8), d.slice(8, 10), d.slice(10, 12)].filter(Boolean);
  return '+' + parts.join(' ');
};

const useReducedMotion = () => {
  const [reduced, setReduced] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    setReduced(mq.matches);
    const on = (e) => setReduced(e.matches);
    mq.addEventListener('change', on);
    return () => mq.removeEventListener('change', on);
  }, []);
  return reduced;
};

const useCountUp = (value, reduced, ms = 700) => {
  const [v, setV] = useState(value);
  const cur = useRef(value);
  useEffect(() => {
    if (reduced) { cur.current = value; setV(value); return; }
    const from = cur.current;
    const start = performance.now();
    let raf;
    const tick = (t) => {
      const p = Math.min((t - start) / ms, 1);
      cur.current = from + (value - from) * (1 - Math.pow(1 - p, 3));
      setV(cur.current);
      if (p < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [value, reduced, ms]);
  return v;
};

// Planshetga "jonli" qabul tushib turadi, 10 ta bog'bondan keyin yangi kun
const START = feedData.slice(0, 2);
const startRows = () => START.map((r, i) => ({ ...r, id: `s${i}-${Date.now()}` })).reverse();
const startTotals = () => ({
  kg: START.reduce((s, r) => s + r.kg, 0),
  sum: START.reduce((s, r) => s + r.kg * r.price, 0),
  count: START.length
});

const useLiveFeed = (reduced) => {
  const [rows, setRows] = useState(startRows);
  const [totals, setTotals] = useState(startTotals);
  const idx = useRef(START.length);

  useEffect(() => {
    if (reduced) return;
    const id = setInterval(() => {
      if (idx.current >= 10) {
        idx.current = START.length;
        setRows(startRows());
        setTotals(startTotals());
        return;
      }
      const r = feedData[idx.current % feedData.length];
      const row = { ...r, id: `r${idx.current}-${Date.now()}` };
      idx.current += 1;
      setRows((p) => [row, ...p].slice(0, 4));
      setTotals((t) => ({ kg: t.kg + r.kg, sum: t.sum + r.kg * r.price, count: t.count + 1 }));
    }, 2600);
    return () => clearInterval(id);
  }, [reduced]);

  return { rows, totals };
};

const GlobalStyles = () => (
  <style>{`
    @keyframes rowIn { from { opacity:0; transform:translateY(-14px) scale(.97); background:rgba(34,197,94,.35) } to { opacity:1; transform:none; background:rgba(255,255,255,.04) } }
    .row-in { animation: rowIn .7s ease-out both; }
    @keyframes floaty { 0%,100% { transform:translateY(0) } 50% { transform:translateY(-10px) } }
    .floaty { animation: floaty 6s ease-in-out infinite; }
    @keyframes printOut { from { transform:translateY(-40px); opacity:0; clip-path:inset(0 0 100% 0) } to { transform:none; opacity:1; clip-path:inset(0 0 0 0) } }
    .print-out { animation: printOut .9s cubic-bezier(.2,.8,.2,1) both; }
    @keyframes glow { 0%,100% { opacity:.35 } 50% { opacity:.6 } }
    .glow { animation: glow 5s ease-in-out infinite; }
    @keyframes barIn { from { transform:translateY(100%) } to { transform:none } }
    .bar-in { animation: barIn .35s ease-out both; }
    .reveal { opacity:0; transform:translateY(28px); transition:opacity .8s ease, transform .8s ease; }
    .reveal.in { opacity:1; transform:none; }
    .paper { background-color:#fbf6e4; background-image:repeating-linear-gradient(transparent 0 35px, #c7d4e6 35px 36px); }
    .hand { font-family:'Caveat','Segoe Print','Comic Sans MS',cursive; }
    @media (prefers-reduced-motion: reduce) {
      .row-in,.floaty,.print-out,.glow,.bar-in { animation:none; }
      .reveal { opacity:1; transform:none; transition:none; }
    }
  `}</style>
);

// Reveal faqat tashqi qatlamni harakatlantiradi. Hover effektlarni ichki div'ga qo'ying.
const Reveal = ({ children, delay = 0, className = '' }) => {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { setInView(true); io.disconnect(); }
    }, { threshold: 0.15 });
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return (
    <div ref={ref} className={`reveal ${inView ? 'in' : ''} ${className}`} style={{ transitionDelay: `${delay}ms` }}>
      {children}
    </div>
  );
};

const SectionTitle = ({ eyebrow, title, subtitle }) => (
  <Reveal className="text-center max-w-3xl mx-auto mb-12 sm:mb-16 px-4">
    {eyebrow && <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-green-400 mb-3">{eyebrow}</p>}
    <h2 className="text-3xl sm:text-4xl md:text-5xl font-black tracking-tight text-white mb-4">{title}</h2>
    {subtitle && <p className="text-base sm:text-lg text-gray-300 leading-relaxed">{subtitle}</p>}
  </Reveal>
);

const Logo = ({ onClick, small = false }) => (
  <button type="button" onClick={onClick} aria-label="Hosilim - bosh sahifa" className="flex items-center gap-2 text-left">
    <span className={`${small ? 'w-8 h-8 rounded-lg' : 'w-10 h-10 rounded-xl'} bg-green-500 flex items-center justify-center shadow-lg shadow-green-500/30`}>
      <img src="/logo-white.png" alt="" className={small ? 'w-5 h-5' : 'w-6 h-6'} width={small ? 20 : 24} height={small ? 20 : 24} />
    </span>
    <span className="flex flex-col">
      <span className="text-xl font-black tracking-tight leading-none text-white">Hosilim</span>
      {!small && <span className="text-[9px] uppercase font-bold text-green-500 tracking-wider mt-1">Agro platforma</span>}
    </span>
  </button>
);

// ---------- HERO: JONLI PLANSHET ----------
const TabletMock = ({ reduced }) => {
  const { rows, totals } = useLiveFeed(reduced);
  const kg = useCountUp(totals.kg, reduced);
  const sum = useCountUp(totals.sum, reduced);

  return (
    <div className="relative w-full max-w-[520px] mx-auto">
      <div className="absolute -inset-10 bg-green-500/30 blur-[90px] rounded-full glow pointer-events-none" />

      <div className="relative rounded-[2.2rem] bg-gray-900 p-3 sm:p-4 border border-white/10 shadow-[0_40px_80px_-20px_rgba(0,0,0,0.8)]" style={{ transform: 'perspective(1400px) rotateY(-8deg) rotateX(4deg)' }}>
        <div className="rounded-[1.6rem] bg-gray-950 overflow-hidden border border-white/5">
          <div className="flex items-center justify-between px-5 pt-3 text-[11px] text-gray-500">
            <span>09:41</span>
            <span className="flex items-center gap-1.5"><Wifi size={12} /><BatteryFull size={14} /></span>
          </div>

          <div className="px-5 pt-3 pb-4 flex items-center justify-between">
            <div>
              <p className="text-xs text-gray-400">Qabul punkti</p>
              <p className="text-lg font-black text-white">Bugungi qabul</p>
            </div>
            <span className="flex items-center gap-2 text-xs font-bold text-green-400 bg-green-500/10 border border-green-500/30 px-3 py-1 rounded-full">
              <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse" /> Jonli
            </span>
          </div>

          <div className="grid grid-cols-2 gap-3 px-5">
            <div className="rounded-2xl bg-white/5 border border-white/10 p-3 sm:p-4">
              <p className="text-[11px] uppercase tracking-wider text-gray-400">Jami og'irlik</p>
              <p className="text-xl sm:text-2xl font-black text-white tabular-nums">{fmt(kg)} <span className="text-sm text-gray-400">kg</span></p>
            </div>
            <div className="rounded-2xl bg-green-500/15 border border-green-500/30 p-3 sm:p-4">
              <p className="text-[11px] uppercase tracking-wider text-green-300">To'lanadi</p>
              <p className="text-xl sm:text-2xl font-black text-white tabular-nums">{(sum / 1000000).toFixed(1)} <span className="text-sm text-gray-300">mln so'm</span></p>
            </div>
          </div>

          <div className="px-5 pt-4 pb-2 flex justify-between text-[11px] uppercase tracking-wider text-gray-500">
            <span>Bog'bon</span><span>Summa</span>
          </div>
          <ul className="px-3 space-y-2 min-h-[232px]">
            {rows.map((r) => (
              <li key={r.id} className="row-in flex items-center justify-between rounded-xl px-3 py-2.5 border border-white/5">
                <div className="flex items-center gap-3">
                  <span className="w-9 h-9 rounded-full bg-green-500/20 text-green-300 font-black flex items-center justify-center text-sm">{r.name[0]}</span>
                  <div>
                    <p className="text-sm font-bold text-white">{r.name}</p>
                    <p className="text-[11px] text-gray-400">{r.kg} kg × {fmt(r.price)} · {r.crates} karzinka</p>
                  </div>
                </div>
                <p className="text-sm font-black text-white tabular-nums">{fmt(r.kg * r.price)}</p>
              </li>
            ))}
          </ul>

          <div className="p-4">
            <div className="w-full py-3 rounded-xl bg-green-500 text-white font-bold text-sm flex items-center justify-center gap-2">
              <Printer size={16} aria-hidden="true" /> Hisobotni chop etish
            </div>
          </div>
        </div>
      </div>

      <div className="floaty absolute -left-4 sm:-left-10 bottom-16 bg-white text-gray-900 rounded-2xl px-4 py-3 shadow-2xl flex items-center gap-3">
        <CheckCircle2 className="text-green-600 shrink-0" size={22} aria-hidden="true" />
        <div>
          <p className="text-sm font-black leading-tight">Summa o'zi hisoblandi</p>
          <p className="text-xs text-gray-500">Kalkulyatorsiz</p>
        </div>
      </div>
      <div className="floaty absolute -right-2 sm:-right-8 top-24 bg-gray-900/90 backdrop-blur border border-white/15 rounded-2xl px-4 py-3 shadow-2xl" style={{ animationDelay: '1.5s' }}>
        <p className="text-xs text-gray-400">Qabul qilindi</p>
        <p className="text-lg font-black text-white tabular-nums">{totals.count} ta bog'bon</p>
      </div>
    </div>
  );
};

// ---------- DAFTAR VA HOSILIM SURGICHI ----------
const NotebookSide = () => (
  <div className="paper absolute inset-0 text-[#1f3a8a] hand px-6 sm:px-12 pt-8 overflow-hidden">
    <div className="absolute top-0 bottom-0 left-4 sm:left-8 w-px bg-red-300" />
    <div className="absolute right-10 bottom-16 w-32 h-32 rounded-full" style={{ background: 'radial-gradient(circle, transparent 55%, rgba(120,72,20,.18) 58%, transparent 66%)' }} />
    <p className="text-2xl sm:text-4xl font-bold mb-2 rotate-[-1deg]">Qabul - 14-avgust</p>
    <div className="text-lg sm:text-2xl leading-[36px]">
      <p>Akmal aka 420 kg × 9000 = 3 780 000</p>
      <p>Dilshod aka 780 kg × 8500 =  <span className="text-red-600">6 360 000</span> 6 630 000</p>
      <p>Rustam aka <s>351</s> 315 kg × 9200 = 2 898 000</p>
      <p className="text-red-600 rotate-[-2deg]">karzinka?? 52 ta berildi... 48 qaytdi? 49?</p>
      <p className="rotate-[1deg]">Jami: 13 038 000 ???</p>
      <p className="text-gray-500 text-base sm:text-xl">Sherzod akaniki keyingi betda (qaysi?)</p>
    </div>
  </div>
);

const AppSide = () => (
  <div className="absolute inset-0 bg-gray-950 px-6 sm:px-12 pt-8 overflow-hidden">
    <div className="flex items-center justify-between mb-5">
      <p className="text-lg sm:text-2xl font-black text-white">Qabul - 14-avgust</p>
      <span className="text-xs font-bold text-green-400 bg-green-500/10 border border-green-500/30 px-3 py-1 rounded-full">Saqlandi ✓</span>
    </div>
    <div className="rounded-2xl border border-white/10 overflow-hidden text-sm sm:text-base">
      {[['Akmal aka', 420, 9000, 0], ['Dilshod aka', 780, 8500, 3], ['Rustam aka', 315, 9200, 0]].map(([n, kg, p, left]) => (
        <div key={n} className="grid grid-cols-[1.3fr_1fr_1fr] sm:grid-cols-[1.5fr_1fr_1fr_1fr] gap-2 px-4 py-3 border-b border-white/5 text-gray-200">
          <span className="font-bold text-white">{n}</span>
          <span className="tabular-nums">{kg} kg</span>
          <span className="hidden sm:block tabular-nums text-gray-400">{fmt(p)}</span>
          <span className="tabular-nums font-bold text-right text-white">{fmt(kg * p)}</span>
          {left > 0 && <span className="col-span-full text-xs text-yellow-300">{left} ta karzinka qaytmagan</span>}
        </div>
      ))}
      <div className="flex justify-between px-4 py-4 bg-green-500/15 text-white font-black text-base sm:text-xl">
        <span>Jami</span><span className="tabular-nums">13 308 000 so'm</span>
      </div>
    </div>
    <p className="mt-4 text-sm text-gray-400">Hammasi avtomatik hisoblangan va bulutda saqlangan.</p>
  </div>
);

const BeforeAfter = ({ reduced }) => {
  const [pos, setPos] = useState(55);
  const boxRef = useRef(null);
  const touched = useRef(false);

  // Ekranga chiqqanda surgich bir marta o'zi tebranadi - suriladigan ekanini ko'rsatadi
  useEffect(() => {
    if (reduced) return;
    const el = boxRef.current;
    if (!el) return;
    let raf;
    const io = new IntersectionObserver(([e]) => {
      if (!e.isIntersecting) return;
      io.disconnect();
      const start = performance.now() + 400;
      const tick = (t) => {
        if (touched.current) return;
        const p = Math.max(0, Math.min((t - start) / 2200, 1));
        setPos(55 + Math.sin(p * Math.PI * 2) * 25 * (1 - p));
        if (p < 1) raf = requestAnimationFrame(tick);
      };
      raf = requestAnimationFrame(tick);
    }, { threshold: 0.5 });
    io.observe(el);
    return () => { io.disconnect(); cancelAnimationFrame(raf); };
  }, [reduced]);

  return (
    <section id="compare" className="py-20 sm:py-28 px-4 scroll-mt-24">
      <SectionTitle eyebrow="Farqni o'zingiz ko'ring" title="Bir kunlik qabul: daftarda va Hosilimda"
        subtitle="Chiziqni suring. Daftardagi jami summada xato bor, uni topa olasizmi?" />
      <Reveal>
        <div ref={boxRef} className="relative max-w-5xl mx-auto h-[440px] sm:h-[480px] rounded-3xl overflow-hidden select-none border border-white/15 shadow-[0_40px_80px_-20px_rgba(0,0,0,0.8)]">
          <AppSide />
          <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
            <NotebookSide />
          </div>
          <div className="absolute inset-y-0 w-1 bg-white shadow-[0_0_24px_rgba(255,255,255,0.8)] pointer-events-none" style={{ left: `${pos}%` }}>
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white text-gray-900 flex items-center justify-center shadow-xl">
              <ArrowLeftRight size={20} aria-hidden="true" />
            </div>
          </div>
          <span className="absolute bottom-4 left-4 px-3 py-1 rounded-full bg-red-500/90 text-white text-sm font-bold pointer-events-none">Daftar</span>
          <span className="absolute bottom-4 right-4 px-3 py-1 rounded-full bg-green-500/90 text-white text-sm font-bold pointer-events-none">Hosilim</span>
          <input type="range" min="0" max="100" value={pos}
            onPointerDown={() => { touched.current = true; }}
            onChange={(e) => { touched.current = true; setPos(+e.target.value); }}
            aria-label="Daftar va Hosilimni taqqoslash"
            className="absolute inset-0 w-full h-full opacity-0 cursor-ew-resize"
            style={{ touchAction: 'pan-y' }} />
        </div>
      </Reveal>
      <p className="text-center text-gray-400 mt-5 text-sm">To'g'ri javob: 13 308 000. Daftarda 270 000 so'm "yo'qolgan".</p>
    </section>
  );
};

// ---------- JONLI DEMO ----------
const demoFarmers = ['Akmal aka', 'Dilshod aka', 'Rustam aka'];

const LiveDemo = ({ reduced }) => {
  const [farmer, setFarmer] = useState(0);
  const [kg, setKg] = useState(850);
  const [price, setPrice] = useState(9000);
  const [given, setGiven] = useState(60);
  const [returned, setReturned] = useState(55);
  const [receiptKey, setReceiptKey] = useState(0);

  const total = useCountUp(kg * price, reduced);
  const debt = given - returned;
  const hide = () => setReceiptKey(0);

  const numInput = (value, set, label) => (
    <input type="number" inputMode="numeric" value={value} min="0" aria-label={label}
      onChange={(e) => { set(Math.max(0, +e.target.value || 0)); hide(); }}
      className="mt-2 w-full rounded-xl bg-white/10 border border-white/15 px-4 py-3 text-white font-bold focus:outline-none focus:border-green-400" />
  );

  return (
    <section id="demo" className="py-20 sm:py-28 px-4 scroll-mt-24">
      <SectionTitle eyebrow="Ro'yxatdan o'tmasdan" title="Qabulni o'zingiz qilib ko'ring"
        subtitle="Raqamlarni o'zgartiring, summa va karzinka qoldig'i o'zi hisoblanadi." />

      <Reveal className="max-w-5xl mx-auto grid md:grid-cols-2 gap-6">
        <div className="rounded-[2rem] p-6 sm:p-8 bg-white/5 backdrop-blur-xl border border-white/10 space-y-6">
          <div>
            <p className="text-sm text-gray-300 mb-2">Bog'bon</p>
            <div className="flex gap-2 flex-wrap">
              {demoFarmers.map((f, i) => (
                <button key={f} onClick={() => { setFarmer(i); hide(); }} aria-pressed={farmer === i}
                  className={`px-4 py-2 rounded-full text-sm font-bold border transition-colors ${farmer === i ? 'bg-green-500 border-green-400 text-white' : 'bg-white/5 border-white/15 text-gray-300 hover:bg-white/10'}`}>
                  {f}
                </button>
              ))}
            </div>
          </div>

          <label className="block">
            <span className="flex justify-between text-sm text-gray-300 mb-3"><span>Og'irlik</span><b className="text-white text-base">{fmt(kg)} kg</b></span>
            <input type="range" min="50" max="3000" step="10" value={kg}
              onChange={(e) => { setKg(+e.target.value); hide(); }} className="w-full accent-green-500 h-2" />
          </label>

          <label className="block">
            <span className="text-sm text-gray-300">Narx (so'm/kg)</span>
            {numInput(price, setPrice, 'Narx')}
          </label>

          <div className="grid grid-cols-2 gap-4">
            <label className="block"><span className="text-sm text-gray-300">Berilgan karzinka</span>{numInput(given, setGiven, 'Berilgan karzinka')}</label>
            <label className="block"><span className="text-sm text-gray-300">Qaytgan karzinka</span>{numInput(returned, setReturned, 'Qaytgan karzinka')}</label>
          </div>
        </div>

        <div className="rounded-[2rem] p-6 sm:p-8 bg-green-500/10 backdrop-blur-xl border border-green-400/30 flex flex-col">
          <p className="text-sm uppercase tracking-widest text-green-300 font-bold">To'lanadigan summa</p>
          <p className="text-4xl sm:text-6xl font-black text-white my-3 tabular-nums break-all" aria-live="polite">
            {fmt(total)} <span className="text-2xl text-gray-300">so'm</span>
          </p>

          <div className={`flex items-center gap-3 rounded-xl px-4 py-3 mb-6 ${debt > 0 ? 'bg-yellow-500/15 text-yellow-300' : debt < 0 ? 'bg-red-500/15 text-red-300' : 'bg-green-500/15 text-green-300'}`}>
            <Box size={20} aria-hidden="true" />
            <span className="font-bold">
              {debt > 0 ? `${demoFarmers[farmer]}da ${debt} ta karzinka qoldi` : debt < 0 ? "Qaytgan karzinka berilganidan ko'p - tekshiring" : "Karzinkalar to'liq qaytdi"}
            </span>
          </div>

          <button onClick={() => setReceiptKey((k) => k + 1)}
            className="mt-auto w-full py-4 rounded-2xl bg-green-500 hover:bg-green-400 transition-colors font-bold text-white flex items-center justify-center gap-2 shadow-[0_0_40px_rgba(34,197,94,0.35)]">
            <Printer size={20} aria-hidden="true" /> Chek chiqarish
          </button>

          {receiptKey > 0 && (
            <div key={receiptKey} className="print-out mt-4 bg-white text-gray-900 rounded-xl p-5 font-mono text-sm shadow-2xl">
              <p className="font-bold text-center mb-3">HOSILIM - QABUL CHEKI</p>
              <p>Bog'bon: {demoFarmers[farmer]}</p>
              <p>Og'irlik: {fmt(kg)} kg × {fmt(price)}</p>
              <p>Karzinka: {given} berildi / {returned} qaytdi</p>
              <p className="border-t border-dashed border-gray-400 mt-3 pt-3 font-bold text-base">JAMI: {fmt(kg * price)} so'm</p>
            </div>
          )}
          <p className="text-xs text-white/50 mt-3">Bu namuna demo. Haqiqiy tizimda ma'lumotlar bulutga saqlanadi.</p>
        </div>
      </Reveal>
    </section>
  );
};

// ---------- ARIZA FORMASI ----------
const LeadForm = ({ plan, setPlan }) => {
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('+998 ');
  const [status, setStatus] = useState('idle'); // idle | invalid | sending | ok | error

  if (!LEAD_ENDPOINT) return null; // manzil ulanmagan bo'lsa arizalar yo'qolmasligi uchun forma ko'rinmaydi

  const digits = phone.replace(/\D/g, '');
  const valid = name.trim().length >= 2 && digits.length === 12;

  const submit = async (e) => {
    e.preventDefault();
    if (e.currentTarget.website.value) return; // spam bot
    if (!valid) { setStatus('invalid'); return; }
    setStatus('sending');
    try {
      const res = await fetch(LEAD_ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: name.trim(), phone: `+${digits}`, plan, source: 'hosilim.uz landing' })
      });
      if (!res.ok) throw new Error('bad status');
      setStatus('ok');
    } catch {
      setStatus('error');
    }
  };

  if (status === 'ok') {
    return (
      <div className="max-w-xl mx-auto rounded-3xl p-8 bg-green-500/15 border border-green-400/40 text-center mb-10">
        <CheckCircle2 size={44} className="mx-auto text-green-400 mb-3" aria-hidden="true" />
        <p className="text-2xl font-black text-white mb-2">Rahmat, arizangiz qabul qilindi</p>
        <p className="text-gray-300">Tez orada siz bilan bog'lanamiz.</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} noValidate className="max-w-xl mx-auto rounded-3xl p-6 sm:p-8 bg-white/5 border border-white/15 text-left space-y-4 mb-10">
      <p className="text-lg font-black text-white">Demo uchun ariza qoldiring</p>
      <input name="website" tabIndex={-1} autoComplete="off" className="hidden" aria-hidden="true" />
      <label className="block">
        <span className="text-sm text-gray-300">Ismingiz</span>
        <input value={name} onChange={(e) => setName(e.target.value)} autoComplete="name" required
          className="mt-2 w-full rounded-xl bg-white/10 border border-white/15 px-4 py-3 text-white focus:outline-none focus:border-green-400" />
      </label>
      <label className="block">
        <span className="text-sm text-gray-300">Telefon raqam</span>
        <input value={phone} onChange={(e) => setPhone(formatPhone(e.target.value))} type="tel" inputMode="tel" autoComplete="tel" required
          className="mt-2 w-full rounded-xl bg-white/10 border border-white/15 px-4 py-3 text-white tabular-nums focus:outline-none focus:border-green-400" />
      </label>
      <div>
        <span className="text-sm text-gray-300">Qiziqtirgan tarif</span>
        <div className="mt-2 flex flex-wrap gap-2">
          {planOptions.map((p) => (
            <button type="button" key={p} onClick={() => setPlan(p)} aria-pressed={plan === p}
              className={`px-4 py-2 rounded-full text-sm font-bold border transition-colors ${plan === p ? 'bg-green-500 border-green-400 text-white' : 'bg-white/5 border-white/15 text-gray-300 hover:bg-white/10'}`}>
              {p}
            </button>
          ))}
        </div>
      </div>
      {status === 'invalid' && <p className="text-sm text-yellow-300" role="alert">Ism va to'liq telefon raqamni kiriting.</p>}
      {status === 'error' && <p className="text-sm text-red-300" role="alert">Yuborib bo'lmadi. Iltimos, {PHONE_DISPLAY} raqamiga qo'ng'iroq qiling.</p>}
      <button type="submit" disabled={status === 'sending'}
        className="w-full py-4 rounded-2xl bg-green-600 hover:bg-green-500 disabled:opacity-60 font-bold text-white flex items-center justify-center gap-2">
        {status === 'sending' ? <><Loader2 size={20} className="animate-spin" aria-hidden="true" /> Yuborilmoqda...</> : 'Ariza yuborish'}
      </button>
    </form>
  );
};

// ---------- ASOSIY KOMPONENT ----------
const HosilimLanding = () => {
  const reduced = useReducedMotion();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [pastHero, setPastHero] = useState(false);
  const [contactVisible, setContactVisible] = useState(false);
  const [plan, setPlan] = useState(planOptions[0]);
  const contactRef = useRef(null);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 20);
      setPastHero(window.scrollY > window.innerHeight * 0.8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    const el = contactRef.current;
    if (!el) return;
    const io = new IntersectionObserver(([e]) => setContactVisible(e.isIntersecting), { threshold: 0.05 });
    io.observe(el);
    return () => io.disconnect();
  }, []);

  const scrollToSection = (id) => {
    setMobileOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth' });
  };
  const toTop = () => window.scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
  const goDashboard = () => { window.location.href = DASHBOARD_URL; };
  const choosePlan = (title) => { setPlan(title); scrollToSection('contact'); };

  const showBar = pastHero && !contactVisible && !mobileOpen;

  return (
    <div className="min-h-screen font-sans overflow-x-hidden bg-gray-950 text-gray-100 relative">
      <GlobalStyles />
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:top-3 focus:left-3 focus:z-[60] bg-green-600 text-white px-4 py-2 rounded-lg font-bold">
        Asosiy kontentga o'tish
      </a>
      <div className="pointer-events-none fixed inset-0 z-0" style={{ background: 'radial-gradient(60% 40% at 80% 30%, rgba(34,197,94,0.08), transparent), radial-gradient(50% 40% at 10% 80%, rgba(34,197,94,0.06), transparent)' }} />

      {/* HEADER */}
      <header className={`fixed top-0 w-full z-50 transition-colors duration-500 border-b ${scrolled || mobileOpen ? 'bg-gray-950/85 backdrop-blur-xl border-white/10' : 'bg-transparent border-transparent'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between">
          <Logo onClick={toTop} />
          <nav aria-label="Asosiy navigatsiya" className="hidden lg:flex items-center gap-6">
            {navItems.map((item) => (
              <button key={item.id} onClick={() => scrollToSection(item.id)}
                className="text-[13px] font-bold uppercase tracking-tight text-white/85 hover:text-green-400 transition-colors">
                {item.label}
              </button>
            ))}
          </nav>
          <div className="flex items-center gap-2 sm:gap-3">
            <button onClick={goDashboard} className="hidden sm:block px-4 py-2.5 text-white font-bold rounded-lg border border-white/20 hover:bg-white/10 text-sm">
              Kabinetga kirish
            </button>
            <button onClick={() => scrollToSection('contact')} className="px-4 py-2.5 bg-green-600 hover:bg-green-500 text-white font-bold rounded-lg text-xs sm:text-sm">
              Demo so'rash
            </button>
            <button className="lg:hidden p-2 text-white/80 hover:text-white" aria-label="Menyuni ochish yoki yopish"
              aria-expanded={mobileOpen} onClick={() => setMobileOpen(!mobileOpen)}>
              {mobileOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
        {mobileOpen && (
          <nav aria-label="Mobil navigatsiya" className="lg:hidden bg-gray-950/95 backdrop-blur-xl border-t border-white/10 px-4 pb-4 flex flex-col">
            {navItems.map((item) => (
              <button key={item.id} onClick={() => scrollToSection(item.id)}
                className="text-left text-sm font-bold uppercase py-3 border-b border-white/10 text-white hover:text-green-400">
                {item.label}
              </button>
            ))}
            <button onClick={goDashboard} className="text-left text-sm font-bold uppercase py-3 text-green-400">Kabinetga kirish</button>
          </nav>
        )}
      </header>

      <main id="main" className="relative z-10">
        {/* HERO */}
        <section className="relative min-h-screen flex items-center pt-28 pb-20 overflow-hidden">
          <div className="absolute inset-0 bg-cover bg-center" style={{ backgroundImage: `url('${HERO_BG}')` }} />
          <div className="absolute inset-0 bg-gradient-to-r from-gray-950 via-gray-950/80 to-gray-950/30" />
          <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-gray-950 to-transparent" />

          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 grid lg:grid-cols-2 gap-14 lg:gap-8 items-center w-full">
            <div className="text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-3 py-2 border rounded-full text-xs sm:text-sm font-bold mb-6 bg-white/10 border-white/20 text-green-300 backdrop-blur-md">
                <CheckCircle2 className="w-4 h-4 shrink-0" aria-hidden="true" />
                Meva qabul punktlari, dallollar va eksportchilar uchun
              </div>
              <h1 className="text-4xl sm:text-6xl xl:text-7xl font-black leading-[1.05] tracking-tight text-white mb-6">
                Meva qabuli, karzinka va hisob-kitob <span className="text-green-400">bitta planshetda</span>
              </h1>
              <p className="text-base sm:text-xl text-white/80 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-10">
                Hosilim bog'bonlardan qabulni, karzinka qoldig'ini va to'lovlarni avtomatik hisoblaydi. Daftar va kalkulyator bilan soatlab o'tirish ortda qoladi.
              </p>
              <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center lg:justify-start">
                <button onClick={() => scrollToSection('demo')}
                  className="px-8 py-4 bg-green-600 hover:bg-green-500 text-white font-bold rounded-full shadow-[0_0_40px_rgba(22,163,74,0.45)] flex items-center justify-center gap-3 transition-all hover:-translate-y-1 text-base sm:text-lg">
                  Hoziroq sinab ko'rish <ArrowUpRight size={22} aria-hidden="true" />
                </button>
                <button onClick={() => scrollToSection('compare')}
                  className="px-8 py-4 bg-white/10 hover:bg-white/20 text-white font-bold rounded-full border border-white/20 text-base sm:text-lg backdrop-blur-md">
                  Farqni ko'rish
                </button>
              </div>
            </div>

            <div aria-hidden="true">
              <TabletMock reduced={reduced} />
              <p className="text-center text-xs text-white/40 mt-6">Ekrandagi raqamlar namuna</p>
            </div>
          </div>
        </section>

        <BeforeAfter reduced={reduced} />

        {/* QANDAY ISHLAYDI */}
        <section id="how" className="py-20 sm:py-28 scroll-mt-24">
          <div className="max-w-7xl mx-auto px-4 sm:px-6">
            <SectionTitle eyebrow="Qanday ishlaydi" title="Bir kunlik ish uch qadamda" />
            <ol className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {stepsData.map((s, i) => (
                <li key={s.title}>
                  <Reveal delay={i * 120} className="h-full">
                    <div className="h-full rounded-3xl p-6 sm:p-8 border bg-white/5 border-white/10 hover:border-green-500/40 transition-colors">
                      <div className="flex items-center justify-between mb-5">
                        <div className="w-14 h-14 rounded-xl flex items-center justify-center border bg-green-500/15 text-green-400 border-green-400/30" aria-hidden="true">{s.icon}</div>
                        <span className="text-6xl font-black text-white/10" aria-hidden="true">{i + 1}</span>
                      </div>
                      <p className="text-xs font-bold uppercase tracking-wider text-green-300 mb-1">{s.time}</p>
                      <h3 className="text-xl font-bold mb-2 text-white">{s.title}</h3>
                      <p className="text-gray-300 leading-relaxed">{s.desc}</p>
                    </div>
                  </Reveal>
                </li>
              ))}
            </ol>
          </div>
        </section>

        <LiveDemo reduced={reduced} />

        {/* MUAMMO / YECHIM */}
        <section id="problems" className="py-20 sm:py-28 scroll-mt-24">
          <div className="max-w-7xl mx-auto px-4 sm:px-6">
            <SectionTitle eyebrow="Nega bu muhim" title="Daftar bilan ishlashning yashirin narxi"
              subtitle="Mavsum qizig'ida har bir xato raqam yoki yo'qolgan karzinka to'g'ridan-to'g'ri daromadingizdan ketadi." />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
              <Reveal className="h-full">
                <div className="h-full rounded-3xl p-6 md:p-10 border bg-red-500/[0.07] border-red-500/25">
                  <h3 className="text-xl sm:text-2xl font-black mb-6 flex items-center gap-3 text-white"><XOctagon className="w-7 h-7 text-red-400" aria-hidden="true" /> Hozirgi usul</h3>
                  <ul className="space-y-5 text-gray-200">
                    {[
                      ["Daftar yo'qoladi yoki aralashadi", "Bir sahifa yo'qolsa, kim qancha topshirgani noma'lum bo'lib qoladi."],
                      ['Kalkulyatorda soatlab hisob', "Bitta noto'g'ri raqam tufayli hammasini qaytadan hisoblaysiz."],
                      ['Karzinkalar izsiz ketadi', "Qaysi bog'bonda nechta karzinka qolgani aniq bo'lmaydi."],
                      ["Ish bitta odamga bog'liq", "Daftarni tushunadigan odam bo'lmasa, qabul to'xtab qoladi."]
                    ].map(([t, d]) => (
                      <li key={t} className="flex gap-4"><span className="font-bold text-red-400" aria-hidden="true">✗</span><p><strong className="text-white">{t}.</strong> {d}</p></li>
                    ))}
                  </ul>
                </div>
              </Reveal>
              <Reveal delay={150} className="h-full">
                <div className="h-full rounded-3xl p-6 md:p-10 border bg-green-500/10 border-green-500/35">
                  <h3 className="text-xl sm:text-2xl font-black mb-6 flex items-center gap-3 text-white"><CheckCircle2 className="w-7 h-7 text-green-300" aria-hidden="true" /> Hosilim bilan</h3>
                  <ul className="space-y-5 text-gray-100">
                    {[
                      ["Ma'lumotlar bulutda", "Planshet sinsa ham hech narsa yo'qolmaydi."],
                      ['Hisob avtomatik', "Tonna, narx va qarzdorlik o'zi hisoblanadi, yakuniy summa tayyor chiqadi."],
                      ["Karzinka qoldig'i ko'rinib turadi", "Har bir bog'bon bo'yicha, istalgan paytda."],
                      ['Har qanday xodim ishlata oladi', 'Maxsus bilim shart emas.']
                    ].map(([t, d]) => (
                      <li key={t} className="flex gap-4"><span className="font-bold text-green-400" aria-hidden="true">✓</span><p><strong className="text-white">{t}.</strong> {d}</p></li>
                    ))}
                  </ul>
                </div>
              </Reveal>
            </div>
          </div>
        </section>

        {/* IMKONIYATLAR */}
        <section id="features" className="py-20 sm:py-28 scroll-mt-24">
          <div className="max-w-7xl mx-auto px-4 sm:px-6">
            <SectionTitle eyebrow="Imkoniyatlar" title="Mavsumning butun jarayoni bitta tizimda"
              subtitle="Bog'dan qabul punktigacha, sovuq omborgacha va eksport mashinasigacha." />
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {featuresData.map((f, i) => (
                <Reveal key={f.title} delay={(i % 3) * 100} className="h-full">
                  <div className="group h-full rounded-2xl p-6 sm:p-8 border bg-white/5 border-white/10 hover:bg-white/[0.08] hover:border-green-500/40 hover:-translate-y-1 transition-all duration-300">
                    <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-5 border bg-green-500/15 text-green-400 border-green-400/30 group-hover:scale-110 transition-transform" aria-hidden="true">{f.icon}</div>
                    <h3 className="text-lg sm:text-xl font-bold mb-2 text-white">{f.title}</h3>
                    <p className="text-gray-300 leading-relaxed">{f.desc}</p>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </section>

        {/* AFZALLIKLAR */}
        <section id="benefits" className="py-20 sm:py-28 scroll-mt-24">
          <div className="max-w-7xl mx-auto px-4 sm:px-6">
            <SectionTitle title={<>Nega aynan <span className="text-green-400">Hosilim</span>?</>}
              subtitle="Murakkab dastur emas: xodimlaringiz tez o'rganib oladigan oddiy vosita." />
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {benefitsData.map((b, i) => (
                <Reveal key={b.title} delay={(i % 2) * 150} className="h-full">
                  <div className="relative h-full min-h-[260px] rounded-3xl overflow-hidden border border-white/15 bg-gray-800 group">
                    <div className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105" style={{ backgroundImage: `url(${b.bgImage})` }} />
                    <div className="absolute inset-0 bg-gradient-to-t from-gray-950 via-gray-950/70 to-gray-950/20" />
                    <div className="relative z-10 h-full flex flex-col justify-end p-6 sm:p-10 text-white">
                      <div className="mb-4 text-green-400" aria-hidden="true">{b.icon}</div>
                      <h3 className="text-xl sm:text-2xl font-black mb-2">{b.title}</h3>
                      <p className="text-gray-200 leading-relaxed">{b.desc}</p>
                    </div>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </section>

        {/* TARIFLAR */}
        <section id="pricing" className="py-20 sm:py-28 scroll-mt-24">
          <div className="max-w-7xl mx-auto px-4 sm:px-6">
            <SectionTitle eyebrow="Tariflar" title="Qabul hajmingizga mosini tanlang" subtitle="Narxlar oylik. Tanlashda ikkilansangiz, qo'ng'iroq qiling." />
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 lg:gap-6 items-stretch pt-4">
              {pricingData.map((p, i) => {
                const primary = p.theme === 'primary';
                return (
                  <Reveal key={p.title} delay={i * 120} className="h-full">
                    <div className={`relative h-full rounded-[2rem] p-7 sm:p-10 border flex flex-col transition-transform ${primary ? 'bg-green-500/15 border-green-400/50 shadow-[0_0_60px_rgba(34,197,94,0.25)] lg:-translate-y-4' : p.theme === 'dark' ? 'bg-black/40 border-white/10' : 'bg-white/5 border-white/15'}`}>
                      {p.badge && <span className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 rounded-full bg-green-500 text-white text-xs font-bold whitespace-nowrap">{p.badge}</span>}
                      <h3 className="text-2xl sm:text-3xl font-black text-white mb-2">{p.title}</h3>
                      <p className="text-gray-300 mb-6">{p.desc}</p>
                      <p className="text-4xl sm:text-5xl font-black text-white mb-8">{p.price}<span className="text-lg font-medium text-gray-400 ml-1">/oy</span></p>
                      <ul className="space-y-4 mb-10 flex-1">
                        {p.features.map(([text, ok]) => (
                          <li key={text} className={`flex gap-3 items-center ${ok ? 'text-white' : 'text-white/40'}`}>
                            {ok ? <CheckCircle2 size={22} className="text-green-400 shrink-0" aria-hidden="true" /> : <X size={22} className="shrink-0" aria-hidden="true" />}
                            <span>{text}{!ok && <span className="sr-only"> - kirmaydi</span>}</span>
                          </li>
                        ))}
                      </ul>
                      <button onClick={() => choosePlan(p.title)}
                        className={`w-full py-4 font-bold rounded-2xl transition-colors ${primary ? 'bg-green-500 hover:bg-green-400 text-white' : 'bg-white/10 hover:bg-white/20 text-white border border-white/20'}`}>
                        {p.title} tarifini tanlash
                      </button>
                    </div>
                  </Reveal>
                );
              })}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section id="faq" className="py-20 sm:py-28 scroll-mt-24">
          <div className="max-w-3xl mx-auto px-4 sm:px-6">
            <SectionTitle title="Ko'p beriladigan savollar" />
            <div className="space-y-3">
              {faqData.map((f, i) => (
                <Reveal key={f.q} delay={i * 80}>
                  <details className="group rounded-2xl border bg-white/5 border-white/10 p-5 open:border-green-500/40">
                    <summary className="flex items-center justify-between cursor-pointer list-none font-bold text-white text-base sm:text-lg">
                      {f.q}
                      <ChevronDown className="shrink-0 ml-4 transition-transform group-open:rotate-180" aria-hidden="true" />
                    </summary>
                    <p className="mt-3 text-gray-300 leading-relaxed">{f.a}</p>
                  </details>
                </Reveal>
              ))}
            </div>
          </div>
        </section>
      </main>

      {/* BOG'LANISH */}
      <footer id="contact" ref={contactRef} className="relative z-10 pt-20 pb-28 lg:pb-10 border-t border-white/10 bg-gradient-to-b from-green-950/40 to-gray-950 scroll-mt-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <Reveal className="text-center mb-14">
            <h2 className="text-3xl sm:text-5xl font-black tracking-tight text-white mb-4">Mavsumni daftarsiz boshlang</h2>
            <p className="text-base sm:text-lg text-gray-300 max-w-2xl mx-auto mb-8">
              Ariza qoldiring, qo'ng'iroq qiling yoki Telegram'da yozing. Tizimni ko'rsatib, biznesingizga mos tarifni tanlashga yordam beramiz.
            </p>
            <LeadForm plan={plan} setPlan={setPlan} />
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <a href={PHONE_LINK} className="w-full max-w-[300px] sm:w-auto px-7 py-4 bg-green-600 hover:bg-green-500 font-bold rounded-xl shadow-lg shadow-green-600/30 flex items-center justify-center gap-2 text-white">
                <Phone size={18} aria-hidden="true" /> {PHONE_DISPLAY}
              </a>
              {HAS_TELEGRAM && (
                <a href={TELEGRAM_URL} target="_blank" rel="noopener noreferrer"
                  className="w-full max-w-[300px] sm:w-auto px-7 py-4 bg-white/10 hover:bg-white/20 border border-white/20 font-bold rounded-xl flex items-center justify-center gap-2 text-white">
                  <Send size={18} aria-hidden="true" /> Telegram'da yozish
                </a>
              )}
            </div>
          </Reveal>
          <div className="border-t pt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-sm border-white/10 text-gray-400">
            <Logo small onClick={toTop} />
            <div>&copy; {new Date().getFullYear()} Hosilim.uz. Barcha huquqlar himoyalangan.</div>
          </div>
        </div>
      </footer>

      {/* MOBIL PASTKI PANEL */}
      {showBar && (
        <div className="bar-in lg:hidden fixed bottom-0 inset-x-0 z-40 px-3 pt-3 bg-gray-950/90 backdrop-blur-xl border-t border-white/10 flex gap-3"
          style={{ paddingBottom: 'max(12px, env(safe-area-inset-bottom))' }}>
          <a href={PHONE_LINK} className="flex-1 py-3.5 rounded-xl bg-white/10 border border-white/20 text-white font-bold flex items-center justify-center gap-2">
            <Phone size={18} aria-hidden="true" /> Qo'ng'iroq
          </a>

          <a href={TELEGRAM_URL} target="_blank" rel="noopener noreferrer"
            className="w-full max-w-[300px] sm:w-auto px-7 py-4 bg-white/10 hover:bg-white/20 border border-white/20 font-bold rounded-xl flex items-center justify-center gap-2 text-white">
            <Send size={18} aria-hidden="true" /> Telegram'da yozish
          </a>

          <button onClick={() => scrollToSection('contact')} className="flex-1 py-3.5 rounded-xl bg-green-600 text-white font-bold">
            Demo so'rash
          </button>
        </div>
      )}
    </div>
  );
};

export default HosilimLanding;